/**
 * 源数据下载
 */
import React from 'react';
import './index.less';
import moment from 'moment';
import { withRouter } from 'react-router-dom';
import {
    Form, Input, Select, Button, message as Message, Table, message, Modal, DatePicker
} from "antd";
import { createFromIconfontCN } from '@ant-design/icons';

import 'moment/locale/zh-cn';
import locale from 'antd/es/date-picker/locale/zh_CN';
import { GetDataSourceList, GetDownLoadUrl, createDataSource } from "../../services/auditDownload/auditDownloadService";
import { GetRoleProjectsEnume } from "../../services/audit/auditService";
import { readTenantCode, readUserCode } from '../../utils/storage';
let _this;
const { Option } = Select;
const IconFont = createFromIconfontCN({
    scriptUrl: [
        '//at.alicdn.com/t/font_2283082_sb9kcktrb1j.js',//icon-shanchu icon-tongji icon-quxiao icon-quyufangwenqushi icon-tianjia1 icon-xiugai
    ],
});

const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 12 },
};

class DownloadComponent extends React.Component {

    constructor(props) {
        super(props);
        _this = this;
        _this.state = {
            dataLists: [], // 列表集合
            columns: [
                {
                    title: '任务名称',
                    width: '8%',
                    render: (text, record, index) => {
                        return (
                            <div className={'con_div'}>
                                <div className={'title'}>{record.taskName}</div>
                            </div>
                        )
                    }
                },
                {
                    title: '项目名称',
                    width: '15%',
                    render: (text, record, index) => {
                        return (
                            <div className={'con_div'}>
                                <div className={'title'}>
                                    {record.projectName}
                                </div>
                            </div>
                        )
                    }
                },
                {
                    title: '开始时间',
                    width: '',
                    render: (text, record, index) => {
                        if (record.startTime) {
                            return (
                                <div className={'con_div'}>
                                    <div className={'sub-title'}>{record.startTime ? record.startTime.replace('T', ' ') : ''}</div>
                                </div>
                            )
                        }
                    }
                },
                {
                    title: '完成时间',
                    width: '',
                    render: (text, record, index) => {
                        if (record.finishTime) {
                            return (
                                <div className={'con_div'}>
                                    <div className={'sub-title'}>{record.finishTime ? record.finishTime.replace('T', ' ') : ''}</div>
                                </div>
                            )
                        }
                    }
                },
                {
                    title: '状态',
                    width: '',
                    render: (text, record, index) => {
                        return (
                            <div className={'con_div current_state'}>
                                {/* 0-下载中 1-已完成 */}
                                <Button type={record.downloadState == '0' ? 'link' : 'text'}>
                                    {
                                        record.downloadState == '0' ? '下载中' : '已完成'
                                    }
                                </Button>
                            </div>
                        )
                    }
                },
                {
                    title: '数据量',
                    width: '8%',
                    render: (text, record, index) => {
                        return (
                            <div className={'con_div'}>
                                {record.dataAmount}
                            </div>
                        )
                    }
                },
                {
                    title: '进度',
                    width: '',
                    render: (text, record, index) => {
                        return (
                            <div className={'con_div'}>
                                <div className={'title'}>{record.percent}</div>
                            </div>
                        )
                    }
                },
                {
                    title: '剩余时间',
                    width: '',
                    render: (text, record, index) => {
                        if (record.leftTime) {
                            return (
                                <div className={'con_div'}>
                                    <div className={'sub-title'}>{record.leftTime}</div>
                                    {/* <div className={'sub-title'}>{utils.formatDuring(record.leftTime)}</div> */}
                                </div>
                            )
                        }
                    }
                },
                {
                    title: '',
                    width: '',
                    render: (text, record) =>
                        <div
                            onClick={eve => {
                                eve.stopPropagation();
                            }}
                            className={'partPop'}
                        >
                            <Button type="link" onClick={() => this.downLoadData(record)} disabled={record.downloadState == '0'}>
                                下载数据
                            </Button>
                        </div>
                },
            ],// 表格 行 配置
            page: 1,//当前页码数
            pagination: { // 分页组件元素对象信息
                onChange: (pageNo) => {
                    this.getPageData(pageNo);
                },
                current: 1,
                pageSize: 10,
                total: 100,
                showSizeChanger: false,
            },
            isCreateVisible: false, // 创建数据下载任务模态框

            projectList: [], // 所有项目
            projectCode: '', // 项目code
            redisKey: '', // 生成进度 
            currentDate: null, // 检索日期
            rowId: '',
            disableDownLoad: false,
            caseStartDate: null, // 起始时间
            caseEndDate: null, // 截至时间
            planCode: null, // 方案编码
            planVersion: null, // 版本号
            subjectStartTime: null, // 受试者创建开始时间
            subjectEndTime: null, // 受试者创建结束时间
        }
    }

    formRef = React.createRef();
    inputRef = React.createRef();

    componentDidMount = () => {

        // 列表
        this.getPageData();
        // 获取项目枚举
        this.getProjectEnume();
    }


    // 获取项目枚举
    getProjectEnume = () => {
        GetRoleProjectsEnume().then(res => {
            this.setState({
                projectList: res || []
            })
        })
    }

    /**
     * 下载数据
     */
    downLoadData = async (record) => {
        GetDownLoadUrl({ id: record.id }).then(res => {
            if (res && res.code == 0) {
                window.open(res.data);

            }
        })
    }
    /**
     * 获取列表数据 
     */
    getPageData = async (curPage) => {
        let { page, projectCode, currentDate } = this.state;
        let userCode = readUserCode()
        let tenantCode = readTenantCode()
        const params = {
            userCode,
            tenantCode,
            projectCode,
            page: curPage ? curPage : page,
            pageSize: this.state.pagination.pageSize,
            startDate: currentDate || '',
            endDate: currentDate || ''
        }

        const res = await GetDataSourceList(params);
        if (res && res.code == 0) {
            _this.setState({
                dataLists: [...res.data.rows],
                page: res.data.page,
                pageSize: res.data.pageSize,
                pagination: {
                    ...this.state.pagination,
                    current: res.data.page,
                    pageSize: res.data.pageSize,
                    total: res.data.total,
                }
            })
        }
    }

    // 取消
    handleCancel = async () => {
        this.setState({
            isCreateVisible: false
        })
    }

    // form过滤空格
    getValueFromEvent = (event) => {
        return event.target.value.replace(/\s+/g, "")
    }

    // 创建下载任务
    createTasks = () => {
        if (this.formRef.current) {
            this.formRef.current.resetFields()
        }

        this.setState({
            isCreateVisible: true
        })
    }

    // 选择项目
    handleSelectChange = (value) => {
        this.setState({
            projectCode: value
        }, () => {
            this.getPageData()
        })
    }

    // 选择日期
    onDateChange = (date, dateString) => {
        this.setState({
            currentDate: dateString
        }, () => {
            this.getPageData()
        })
    };


    handleChange = (code) => {
        const form = this.formRef.current;
        form.setFieldsValue({
            userCodeList: undefined,
        })

    }

    // 创建/提交
    onSubmit = async (values) => {
        const form = this.formRef.current;
        const formValues = form.getFieldsValue(['projectCode']);

        if (!formValues.projectCode || formValues.projectCode == '') {
            message.error('请选择项目！')
            return
        }


        let params = {
            projectCode: formValues.projectCode
        }



        const res = await createDataSource(params);
        if (res && res.code == 0) {
            message.success('创建成功！');

            _this.setState({
                isCreateVisible: false
            }, () => {
                this.getPageData()
            })
        }
    }


    // 病例完成起始时间
    onCaseStartChange = (date, dateString) => {

        this.setState({
            caseStartDate: dateString
        })
        const form = this.formRef.current;
        form.setFieldsValue({
            exportType: dateString ? 3 : 1
        })

    }

    // 病例完成截至时间
    onCaseEndChange = (date, dateString) => {
        this.setState({
            caseEndDate: dateString
        })
        const form = this.formRef.current;
        form.setFieldsValue({
            exportType: dateString ? 3 : 1
        })
    }

    render() {
        let { columns, dataLists, pagination, isCreateVisible, isDownVisible, projectList, currentDate, caseStartDate, caseEndDate } = this.state;

        dataLists.length > 0 && dataLists.map((item, index) => {
            item['key'] = index + 1
        })

        return (
            <div className='sourceData'>
                <div className={'download_wrap'}>
                    <div className={'title_wrap'}>
                        <div>源数据下载</div>
                        <div className={'search_wrap'}>
                            <DatePicker
                                onChange={this.onDateChange}
                                locale={locale}
                                value={currentDate ? moment(currentDate, 'YYYY-MM-DD') : null}
                            />
                            &nbsp;&nbsp;&nbsp;&nbsp;

                            <Select defaultValue="所有项目" onChange={this.handleSelectChange} size='middle'>
                                <Option value={''}>所有项目</Option>
                                {projectList.length > 0 && projectList.map(project => (
                                    <Option key={project.projectCode} value={project.projectCode}>{project.projectName}</Option>
                                ))}
                            </Select>&nbsp;&nbsp;&nbsp;&nbsp;

                            <Button type="primary" size={'middle'} onClick={() => this.createTasks()}>
                                创建数据下载任务
                            </Button>
                        </div>
                    </div>

                    <Table
                        locale={{ emptyText: "暂无数据" }}
                        columns={columns}
                        dataSource={dataLists}
                        pagination={dataLists.length !== 0 && pagination}
                        rowKey={'id'}
                    />
                </div>

                {/* 创建数据下载任务 */}
                <Modal
                    title="创建数据下载任务"
                    visible={isCreateVisible}
                    onOk={this.onSubmit}
                    okText='确认创建'
                    cancelText='关闭'
                    onCancel={this.handleCancel}
                    width='40%'
                >
                    <Form
                        {...layout}
                        name="nest-messages"
                        onFinish={this.onSubmit}
                        requiredMark={true}
                        ref={this.formRef}
                        autoComplete="off"
                        initialValues={{
                            'projectCode': null
                        }}
                    >
                        <Form.Item
                            label="请选择项目"
                            name='projectCode'
                            rules={[{ required: true, message: '请选择项目' }]}
                        >
                            <Select
                                onChange={this.handleChange}
                                placeholder='请选择项目'
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                                allowClear
                            >
                                {projectList.length > 0 && projectList.map(project => (
                                    <Option key={project.projectCode} value={project.projectCode}>{project.projectName}</Option>
                                ))}
                            </Select>
                        </Form.Item>

                    </Form>
                </Modal>

            </div>
        );
    }
}
export default withRouter(DownloadComponent);